import { AcademyNavigatorApiEndpoints } from "@/views/academy/common/academynavigator/AcademyNavigatorApiEndpoints";
import { getRequest } from "@/views/academy/api/apiRequests";

const state = () => ({
  players: [],
  organizations: [],
  favoriteStorageItems: [],
  recentStorageItems: [],
  dialogType: ""
});

const getters = {
  players: (state: { players: [] }) => state.players,
  organizations: (state: { organizations: [] }) => state.organizations,
  favoriteStorageItems: (state: { favoriteStorageItems: [] }) =>
    state.favoriteStorageItems,
  recentStorageItems: (state: { recentStorageItems: [] }) =>
    state.recentStorageItems,
  dialogType: (state: { dialogType: string }) => state.dialogType
};

const mutations = {
  setPlayers: (state: { players: [] }, payload: []) => {
    state.players = payload;
  },

  getOrganizations: (state: { organizations: any }, payload: any) => {
    state.organizations = payload;
  },

  setFavoriteStorageItems: (
    state: { favoriteStorageItems: [] },
    payload: []
  ) => {
    state.favoriteStorageItems = payload;
  },

  setRecentStorageItems: (state: { recentStorageItems: [] }, payload: []) => {
    state.recentStorageItems = payload;
  }
};

const actions = {
  fetchPlayers: async (context: {
    commit: (arg0: string, arg1: any) => void;
  }) => {
    try {
      const res: any = await getRequest(
        AcademyNavigatorApiEndpoints.FETCH_MY_PLAYERS
      );
      context.commit("setPlayers", res.data);
    } catch (e) {
      console.log(e);
    }
  },
  getOrganizations: async (
    context: { commit: (arg0: string, arg1: any) => void },
    payload?: any
  ) => {
    try {
      const res: any = await getRequest(
        AcademyNavigatorApiEndpoints.GET_ORGANIZATION
      );
      context.commit("getOrganizations", res.data);
      payload?.callback && payload?.callback(res.data);
    } catch (e) {
      console.log(e);
    }
  },

  fetchFavoriteStorageItems: async (context: {
    commit: (arg0: string, arg1: any) => void;
  }) => {
    try {
      const res: any = await getRequest(
        AcademyNavigatorApiEndpoints.GET_FAVOURITE_STORAGE_ITEMS
      );
      context.commit("setFavoriteStorageItems", res.data);
    } catch (e) {
      console.log(e);
    }
  },

  fetchRecentStorageItems: async (context: {
    commit: (arg0: string, arg1: any) => void;
  }) => {
    try {
      const res: any = await getRequest(
        `${AcademyNavigatorApiEndpoints.GET_RECENT_STORAGE_ITEMS}?pageSize=5`
      );
      context.commit("setRecentStorageItems", res.data);
    } catch (e) {
      console.log(e);
    }
  },

  findCurrentUser: async (context: any, payload: { callback: any }) => {
    try {
      const { callback } = payload;
      const res: any = await getRequest(
        AcademyNavigatorApiEndpoints.FIND_CURRENT_USER
      );
      if (res) {
        callback && callback(res);
      }
    } catch (e) {
      console.log(e);
    }
  }
};

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
};
